import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Box,
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { useSelector } from 'react-redux';

export default function EnvironmentReview({ data }) {
  const [expanded, setExpanded] = useState(true);
  const environments = useSelector((state) => state.environments || []);
  const project_secrets = useSelector((state) => state.projectSecrets || []);

  if (!data) {
    return null;
  }

  const {
    type,
    custom_image,
    env,
    worker_key_types,
    packages,
    init_script,
    secrets,
  } = data;
  const environment = environments.find((env) => env.id === type);
  const packages_safe = packages || {};

  if (!environment) {
    return null;
  }

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          p: 1,
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <IconButton size='small'>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        <Typography variant='h6'>Environment</Typography>
      </Box>
      <Collapse in={expanded}>
        <Paper sx={{ p: 2, mb: 2 }}>
          {environment.id === 'CUSTOM' ? (
            <>
              <Typography>
                Environment: <b>{environment.name}</b>
              </Typography>
              <Typography>
                Image: <b>{custom_image}</b>
              </Typography>
            </>
          ) : (
            <Typography>
              Environment: <b>{environment.name}</b>
            </Typography>
          )}

          {((packages_safe.pip && packages_safe.pip.length) ||
            (packages_safe.apt && packages_safe.apt.length) ||
            (packages_safe.conda && packages_safe.conda.length)) && (
            <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
              Packages to Install:
            </Typography>
          )}
          {packages_safe.pip && packages_safe.pip.length ? (
            <Typography>
              <b>pip:</b> {packages_safe.pip.join(' ')}
            </Typography>
          ) : null}
          {packages_safe.apt && packages_safe.apt.length ? (
            <Typography>
              <b>apt:</b> {packages_safe.apt.join(' ')}
            </Typography>
          ) : null}
          {packages_safe.conda && packages_safe.conda.length ? (
            <Typography>
              <b>conda:</b> {packages_safe.conda.join(' ')}
            </Typography>
          ) : null}
          {init_script ? (
            <>
              <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
                Initialization Script to Execute:
              </Typography>
              <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                {init_script}
              </Typography>
            </>
          ) : null}
          {env && env.length ? (
            <>
              <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
                Environment Variables:
              </Typography>
              <TableContainer>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Key</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {env.map((e) => (
                      <TableRow key={e.key}>
                        <TableCell>{e.key}</TableCell>
                        <TableCell>{e.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : null}
          {worker_key_types && worker_key_types.length ? (
            <>
              <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
                Project Credentials
              </Typography>
              <Typography>
                Attach credentials: <b>{worker_key_types.join(', ')}</b>
              </Typography>
            </>
          ) : null}
          {secrets && secrets.length ? (
            <>
              <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
                Secrets
              </Typography>
              {secrets.map((secret_name, idx) => {
                const secret = project_secrets.find(
                  (s) => s.name === secret_name,
                );
                return (
                  <Typography key={idx} sx={{ mb: 1 }}>
                    Attach secret <b>{secret_name}</b>
                    {secret ? ` (${secret.description || 'project secret'})` : null}
                  </Typography>
                );
              })}
            </>
          ) : null}
        </Paper>
      </Collapse>
    </Box>
  );
}

